module.exports = __webpack_public_path__ + "img/croxx_null.ed0c49c0.png";